import { useLayoutEffect } from 'react'

import { type FloatingHoverType, type FloatingPopoverType } from '@/defs/floating'
import { useModalProps } from '@/hooks/useModalProps'
import { stripProps } from '@/utils/commonUtil'

import { FloatingModal } from '../../FloatingModal/FloatingModal'

export const FloatingModalTrigger = ({ children, ...props }: FloatingHoverType & FloatingPopoverType) => {
  const popoverProps = stripProps(props, [
    'autoOpen',
    'ignoreScopes',
    'isClickable',
    'onInteractOutside',
    'openDelay',
    'placement',
    'width',
  ])
  const modalProps = useModalProps()
  const { setIsOpen } = modalProps

  useLayoutEffect(() => {
    if (props.autoOpen) setIsOpen(true)
  }, [props.autoOpen, setIsOpen])

  return <FloatingModal {...popoverProps} {...modalProps} trigger={children} />
}
